<template>
  <el-form class="billForm" :model="billForm" ref="billFormRef" label-position="top" :rules="dataRules">
    <el-row :gutter="60" type="flex">
      <!-- First name-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="First name" prop="firstname">
          <el-input v-model="billForm.firstname" v-no-head-space v-no-tail-space></el-input>
        </el-form-item>
      </el-col>
      <!-- Last name-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="Last name" prop="lastname">
          <el-input v-model="billForm.lastname" v-no-head-space v-no-tail-space></el-input>
        </el-form-item>
      </el-col>
      <!-- Email address-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="Email address" prop="email">
          <el-input v-model.trim="billForm.email"></el-input>
        </el-form-item>
      </el-col>
      <!-- Phone-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="Phone" prop="phone">
          <el-input v-model.trim="billForm.phone"></el-input>
        </el-form-item>
      </el-col>
      <!-- Country-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="Country" prop="country">
          <el-select v-model.trim="billForm.country" placeholder="" allow-create filterable default-first-option @change="updateCountry">
            <el-option v-for="item in countryList" :key="item.twocode"
                       :label="item.shortname" :value="item.twocode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- State-->
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item label="State" prop="state">
          <el-select v-if="!isEmpty(provinceList)" v-model.trim="billForm.state" placeholder="" filterable>
            <el-option v-for="item in provinceList" :key="item.code"
                       :label="item.code" :value="item.code">
            </el-option>
          </el-select>
          <el-input v-else v-model.trim="billForm.state"></el-input>
        </el-form-item>
      </el-col>
      <!-- Town/City-->
      <el-col :lg="24" :md="24" :sm="24" :xs="24">
        <el-form-item label="Town / City" prop="city">
          <el-input v-model.trim="billForm.city"></el-input>
        </el-form-item>
      </el-col>
      <!-- Street address-->
      <el-col :lg="24" :md="24" :sm="24" :xs="24">
        <el-form-item class="billForm-address" label="Street address" prop="address">
          <el-input v-model.trim="billForm.address" placeholder="House number and street name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xs="24">
        <el-form-item prop="address1">
          <el-input v-model.trim="billForm.address1" placeholder="Apartment,suite,unit,etc.(Optional)"></el-input>
        </el-form-item>
      </el-col>
      <!-- ZIP Code-->
      <el-col :lg="24" :md="24" :sm="24" :xs="24">
        <el-form-item class="mb-0" label="ZIP Code" prop="postalcode">
          <el-input v-model.trim="billForm.postalcode"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import {
  isEmail,
  isNumber
} from '@/util/validate'
import {
  isEmpty,
  MessageError, startLoading
} from '@/util/util'
import {
  getCountryinfoAll, getProvinceAll
} from "@/request/requests";

export default {
  name: "billDetailsForm",
  data() {
    let validateEmail = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error("Email ERROR"));
      }
      callback();
    };
    let validateNumber = (rule, value, callback) => {
      if (!isNumber(value)) {
        callback(new Error("please enter a number"))
      }
      callback();
    }
    return {
      billForm: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        country: '',
        state: '',
        city: '',
        address: '',
        address1: '',
        postalcode: ''
      },
      countryList: [],
      provinceList: [],
      dataRules: {
        firstname: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"}
        ],
        lastname: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"}
        ],
        email: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"},
          {validator: validateEmail, trigger: "blur"}
        ],
        phone: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"},
          {validator: validateNumber, trigger: "blur"}
        ],
        country: [
          {required: true, message: 'The field cannot be empty', trigger: "change"}
        ],
        state: [
          {required: true, message: 'The field cannot be empty', trigger: "change"}
        ],
        city: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"}
        ],
        address: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"}
        ],
        postalcode: [
          {required: true, message: 'The field cannot be empty', trigger: "blur"}
        ]
      }
    }
  },
  methods: {
    isEmpty,
    init() {
      this.getCountryinfoAllInfo();
    },
    updateCountry() {
      this.provinceList = [];
      if (this.billForm.country == "CA" || this.billForm.country == "US") {
        this.getProvinceAllInfo();
      }
    },
    async getCountryinfoAllInfo() {
      let res = await getCountryinfoAll();
      if (res.status == "200") {
        this.countryList = res.data;
      } else {
        MessageError(res.msg);
      }
    },
    async getProvinceAllInfo() {
      let res = await getProvinceAll(this.billForm.country);
      if (res.status == "200") {
        this.provinceList = res.data;
      } else {
        MessageError(res.msg);
      }
    },
    reset() {
      this.billForm = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        country: '',
        state: '',
        city: '',
        address: '',
        address1: '',
        postalcode: ''
      }
      this.$nextTick(()=>{
        this.$refs['billFormRef'].clearValidate();
      })
    },

  },
}
</script>

<style lang="scss" scoped>
.billForm {
  overflow-y: scroll;
  overflow-x: hidden;
  &-address {
    margin-bottom: 27px;
  }
}
</style>